module.exports = __webpack_public_path__ + "img/vegetable-winter-squash-350x184.ea5b9d86.jpg";